import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

const PRIZES = [
  { name: 'Weekly Lucky Draw', amount: 'GHS 5,000', date: '16 Aug 2026', status: 'funded' },
  { name: 'Weekly Lucky Draw', amount: 'GHS 5,000', date: '16 Aug 2026', status: 'pending' },
  { name: 'Monthly Grand Draw', amount: 'GHS 5,000', date: '16 Aug 2026', status: 'pending' }
]

export default withTranslation()(function PrizeScheduleModal({ t, onClose }) {
  return (
    <div className="fixed inset-0 z-[5000] bg-black bg-opacity-30" onClick={onClose}>
      <div className="absolute inset-y-0 right-0 w-11/12 max-w-sm bg-white shadow-xl overflow-y-auto" onClick={(event) => event.stopPropagation()}>
        <div className="flex items-center justify-between gap-4 px-6 py-5 border-b border-border-lines">
          <button type="button" onClick={onClose} className="text-secondary hover:text-dark-blue">
            <UIcons.UilTimes size={22} />
          </button>

          <h3 className="text-xl font-bold text-dark-blue">{t('billing.prize_schedule.title')}</h3>

          <span className="w-6" />
        </div>

        <div className="p-6">
          <p className="text-xs font-semibold text-secondary uppercase mb-4">{t('billing.prize_schedule.upcoming_prizes')}</p>

          <div className="flex flex-col divide-y divide-border-lines">
            {
              PRIZES.map((prize, index) => (
                <div key={index} className="py-4">
                  <div className="flex items-center justify-between gap-4">
                    <p className="text-base font-semibold text-dark-blue">{prize.name}</p>
                    <p className="text-base text-dark-blue">{prize.amount}</p>
                  </div>

                  <div className="flex items-center gap-2 mt-1">
                    <p className="text-sm text-secondary">{prize.date}</p>
                    <span className="text-secondary">•</span>
                    <span className={`text-sm font-semibold uppercase ${prize.status === 'funded' ? 'text-success' : 'text-[#8a5a00]'}`}>
                      {t(`billing.prize_schedule.${prize.status}`)}
                    </span>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
})
